// ENUMS #############################################################
// API enums *********************************************************
export enum FccInstallationTypeEnum {
	FCC_DATACENTER = 'fccDatacenter',
	LOCAL = 'local'
}

// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// TYPES #############################################################


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TMO - TransitionalModelObject)
// APP MODEL (EMO - EntityModelObject)
